<template>
  <div class="about">
    <el-button type="primary" icon="el-icon-search">测试element plus</el-button>
  </div>
</template>
